<template>
  <vx-modal
    :title="
      !form.uuid ? $t('messages.create.title') : $t('messages.edit.title')
    "
    :active.sync="show"
  >
    <form @submit.prevent="save" @keydown="form.onKeydown($event)">
      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-input
              :label="$t('users.labels.name')"
              name="name"
              class="w-full"
              v-model="form.name"
            />
            <has-error :form="form" field="name" />
          </div>
        </div>
      </div>

      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-input
              :label="$t('users.labels.email')"
              name="email"
              class="w-full"
              type="email"
              v-model="form.email"
            />
            <has-error :form="form" field="email" />
          </div>
        </div>
      </div>

      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-input
              :label="$t('users.labels.phone')"
              name="phone"
              class="w-full"
              v-model="form.phone"
            />
            <has-error :form="form" field="phone" />
          </div>
        </div>
      </div>

      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <label class="text-sm">{{
              $t("users.labels.birthday_date")
            }}</label>
            <flat-pickr
              v-model="form.birthday_date"
              :config="{ dateFormat: 'Y-m-d', maxDate: new Date() }"
              class="w-full"
              name="birthday_date"
            />
            <has-error :form="form" field="birthday_date" />
          </div>
        </div>
      </div>

      <div class="sm:w-12/12">
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vx-select
              :model.sync="form.role_id"
              :label="$t('users.labels.role')"
              :options="roles"
              :translate="false"
              :uuid="false"
              :placeholder="$t('users.labels.select_role')"
            ></vx-select>

            <has-error :form="form" field="role_id" />
          </div>
        </div>
      </div>

      <div class="flex flex-wrap justify-between">
        <div class="mb-6 md:mb-0 mr-4"></div>

        <div class="mb-6 flex flex-wrap justify-between">
          <vs-button class="md:mb-0" v-if="!form.uuid" button="submit">
            {{ $t("messages.create.title") }}
          </vs-button>
          <vs-button class="md:mb-0" v-else button="submit">
            {{ $t("messages.edit.title") }}
          </vs-button>
        </div>
      </div>
    </form>
  </vx-modal>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import Form from 'vform'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  data() {
    return {
      form: new Form({
        uuid: null,
        name: '',
        phone: '',
        birthday_date: '',
        role_id: '',
        email: ''
      }),
      roles: [],
      disableButton: false,
      show: false,
      FormDataErrors: null
    }
  },
  components: {
    flatPickr
  },
  watch: {
    FormDataErrors: {
      handler(error) {
        if (error != null) {
          this.form.errors.set(this.form.extractErrors(error.response))
        }
      }
    },
    show(value) {
      if (!value) {
        this.clearForm()
      }
    }
  },
  computed: {
    locale: {
      get() {
        return this.$store.getters['lang/locale']
      }
    }
  },
  methods: {
    showModal() {
      this.show = true
      this.getRoles()
    },
    save() {
      if (this.form.uuid) {
        this.edit()
      } else {
        this.create()
      }
    },
    async create() {
      let message_title = null
      let message_content = null
      let message_type = null
      const vm = this
      try {
        this.disableButton = true

        this.$vs.loading({ container: '.vx-popup' })

        const params = new FormData()

        for (const key in this.form) {
          params.append(key, this.form[key])
        }
        const { data } = await axios
          .post(`${process.env.VUE_APP_API_URL  }/api/register`, params, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .catch(function (err) {
            vm.$vs.loading.close('.vx-card__body > .con-vs-loading')
            vm.FormDataErrors = err
          })

        this.form = Object.assign(this.form, data)

        this.$parent.getUsers()
        this.$vs.loading.close('.vx-popup > .con-vs-loading')

        message_type = 'success'
        message_content = this.$t(
          'messages.create.messages.success_description'
        )
        message_title = this.$t('messages.create.messages.success')
        this.showMessage(message_type, message_title, message_content)
        this.show = false
      } catch (exception) {
        this.$vs.loading.close('.vx-popup > .con-vs-loading')
        console.log('Ocurrió un error:', exception)
      }
      this.disableButton = false
    },
    async edit() {
      let message_title = null
      let message_content = null
      let message_type = null
      const vm = this
      try {
        this.disableButton = true

        const params = this.formData

        vm.$vs.loading({ container: '.vx-popup' })
        const { data } = await this.form
          .patch(
            `${process.env.VUE_APP_API_URL}/api/users/${this.form.uuid}`,
            params,
            {
              headers: { 'Content-Type': 'multipart/form-data' }
            }
          )
          .catch(function (err) {
            vm.$vs.loading.close('.vx-card__body > .con-vs-loading')
            vm.FormDataErrors = err
          })

        this.$parent.getUsers()
        this.$vs.loading.close('.vx-popup > .con-vs-loading')
        this.form = Object.assign(this.form, data)
        message_type = 'success'
        message_content = this.$t('messages.edit.messages.success_description')
        message_title = this.$t('messages.edit.messages.success')
        this.showMessage(message_type, message_title, message_content)

        this.show = false
      } catch (exception) {
        this.$vs.loading.close('.vx-popup > .con-vs-loading')
        console.log('Ocurrió un error:', exception)
      }
      this.disableButton = false
    },
    async getUser(uuid) {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/users/${uuid}`
        )
        this.form = _.assign(this.form, data)
        this.form.phone = data.profile.phone
        this.form.birthday_date = data.profile.birthday_date
      } catch (error) {
        console.log('Ocurrió un error:', error)
      }
    },
    async getRoles() {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL  }/api/roles?size=1000`
        )
        this.roles = _.filter(data.data, function (item) {
          return item.id != 1
        })
      } catch (error) {
        console.log('Ocurrió un error:', error)
      }
    },
    showMessage(message_type, message_title, message_content) {
      Swal.fire({
        icon: message_type,
        title: message_title,
        text: message_content,
        confirmButtonText: this.$t('ok')
      })
    },
    clearForm() {
      this.form = _.assign(this.form, {
        uuid: null,
        name: '',
        phone: '',
        birthday_date: '',
        role_id: null,
        email: ''
      })
      this.form.clear()
      this.FormDataErrors = null
    }
  }
}
</script>
